import donationHeaderDailyBibleReadingSignUp from "../../../../src/content/daily-bible-reading/donationHeader";
import { NewNames as NewNamesForm } from "@bgea-js/form-templates";
import "../../../../src/content/daily-bible-reading/dailybible.scss";
import * as React from 'react';
export default {
  donationHeaderDailyBibleReadingSignUp,
  NewNamesForm,
  React
};